import { PolicyType, policyTypePopupIdMap } from '../../constants/PolicyType';

type OpenPolicyWindowParams = {
    policyType: PolicyType;
}

export class OpenPolicyWindowHandler {
    public handle(params: OpenPolicyWindowParams): void {
        let policyPopupId = '';

        policyPopupId = policyTypePopupIdMap.get(params.policyType);
        window.app.game_popup(policyPopupId);
    }
}
